import { company as schema } from 'store/common/schemas';
import { createEntitiesReducer, createEntitiesSelector } from './helpers';
import * as companyAdminTeamMembersActionTypes from 'store/features/admin/companies/team-members/action-types';
import * as companyAdminAdvisorsActionTypes from 'store/features/admin/companies/advisors/action-types';
import * as companyActionTypes from 'store/features/companies/action-types';
import * as companyAIPLimitActionTypes from 'store/graphql/ConfigureCompanyAipLimit/action-types';

export const reducer = createEntitiesReducer(schema, (state, action) => {
  switch (action.type) {
    case companyAdminTeamMembersActionTypes.INVITE_TEAM_MEMBER_TO_COMPANY.SUCCESS:
      const {
        teamMemberConnection: invitedTeamMemberConnection,
        prettyId: invitedTeamMemberToPrettyId,
      } = action.payload;
      const teamMemberInvitedToCompany = state[invitedTeamMemberToPrettyId];
      if (invitedTeamMemberConnection && teamMemberInvitedToCompany) {
        return state.merge(
          {
            [invitedTeamMemberToPrettyId]: {
              ...teamMemberInvitedToCompany,
              teamMembers: (teamMemberInvitedToCompany.teamMembers || []).concat(
                invitedTeamMemberConnection.id
              ),
            },
          },
          { deep: true }
        );
      }
      return state;
    case companyAdminTeamMembersActionTypes.DELETE_TEAM_MEMBER_FROM_COMPANY.SUCCESS:
      const {
        teamMemberId: deletedTeamMemberId,
        prettyId: deletedTeamMemberFromPrettyId,
      } = action.payload;
      const teamMemberDeletedFromCompany = state[deletedTeamMemberFromPrettyId];
      if (teamMemberDeletedFromCompany) {
        return state.merge({
          [deletedTeamMemberFromPrettyId]: {
            ...teamMemberDeletedFromCompany,
            teamMembers: (teamMemberDeletedFromCompany.teamMembers || []).filter(
              teamMemberId => teamMemberId !== deletedTeamMemberId
            ),
          },
        });
      }
      return state;
    case companyActionTypes.FETCH_COMPANY_TEAM_MEMBERS_BY_PRETTY_ID.SUCCESS:
      const { prettyId: fetchTeamMembersForPrettyId, teamMemberIds } = action.payload;
      if (fetchTeamMembersForPrettyId) {
        return state.merge(
          {
            [fetchTeamMembersForPrettyId]: {
              teamMembers: teamMemberIds,
            },
          },
          { deep: true }
        );
      }
      return state;
    case companyAdminAdvisorsActionTypes.INVITE_ADVISOR_TO_COMPANY.SUCCESS:
      const {
        advisorConnection: invitedAdvisorConnection,
        prettyId: invitedAdvisorToPrettyId,
      } = action.payload;
      const advisorInvitedToCompany = state[invitedAdvisorToPrettyId];
      if (invitedAdvisorConnection && advisorInvitedToCompany) {
        return state.merge(
          {
            [invitedAdvisorToPrettyId]: {
              ...advisorInvitedToCompany,
              advisors: (advisorInvitedToCompany.advisors || []).concat(
                invitedAdvisorConnection.id
              ),
            },
          },
          { deep: true }
        );
      }
      return state;
    case companyAdminAdvisorsActionTypes.DELETE_ADVISOR_FROM_COMPANY.SUCCESS:
      const { advisorId: deletedAdvisorId, prettyId: deletedAdvisorFromPrettyId } = action.payload;
      const advisorDeletedFromCompany = state[deletedAdvisorFromPrettyId];
      if (advisorDeletedFromCompany) {
        return state.merge({
          [deletedAdvisorFromPrettyId]: {
            ...advisorDeletedFromCompany,
            advisors: (advisorDeletedFromCompany.advisors || []).filter(
              advisorId => advisorId !== deletedAdvisorId
            ),
          },
        });
      }
      return state;
    case companyActionTypes.FETCH_COMPANY_ADVISORS_BY_PRETTY_ID.SUCCESS:
      const { prettyId: fetchAdvisorsForPrettyId, advisorIds } = action.payload;
      if (fetchAdvisorsForPrettyId) {
        return state.merge(
          {
            [fetchAdvisorsForPrettyId]: {
              advisors: advisorIds,
            },
          },
          { deep: true }
        );
      }
      return state;
    case companyAIPLimitActionTypes.CONFIGURE_COMPANY_AIP_LIMIT.SUCCESS:
      const { company, aipLimit } = action.payload;
      const { prettyId } = company;
      if (aipLimit) {
        return state.merge(
          {
            [prettyId]: {
              aipLimit,
            },
          },
          { deep: true }
        );
      }
      return state;
    case companyAIPLimitActionTypes.ALLOW_REPORT_FOR_CANDIDATE.SUCCESS:
      const { company: { prettyId: id }, claimReportAllowed } = action.payload;

      return state.merge(
        {
          [id]: {
            magicLink: {
              claimReportAllowed,
            },
          },
        },
        { deep: true }
      );

    case companyAIPLimitActionTypes.UPDATE_CLAIM_REVIEW.SUCCESS:
      const { company: { prettyId: companyId }, claimReview } = action.payload;

      return state.merge(
        {
          [companyId]: {
            claimReview,
          },
        },
        { deep: true }
      );

    case companyAIPLimitActionTypes.REQUIRE_CV_FOR_COMPANY.SUCCESS:
      const { company: { prettyId: ID }, requireCV } = action.payload;

      return state.merge(
        {
          [ID]: {
            magicLink: {
              requireCV,
            },
          },
        },
        {
          deep: true,
        }
      );

    case companyAIPLimitActionTypes.UPDATE_MAGIC_LINK_VERSION.SUCCESS:
      const { company: { prettyId: companyPrettyId }, version } = action.payload;
      return state.merge(
        {
          [companyPrettyId]: {
            magicLink: {
              version,
            },
          },
        },
        {
          deep: true,
        }
      );
    default:
      return state;
  }
});

export const selector = createEntitiesSelector(schema);



// WEBPACK FOOTER //
// ./src/store/entities/companies.js